import CircularProgress from '@mui/material/CircularProgress';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import Box from '@mui/material/Box';

const useStyles = makeStyles(theme => ({
  loading: {
    zIndex: 99999,
    display: 'flex',
    height: '100%',
    width: '100%',
  },
  fullscreen: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  overlay: {
    background: theme.palette.getContrastText(theme.palette.background.default),
    opacity: 0.5,
  },
  spinner: {
    margin: 'auto',
    color: '#0F8461',
  },
}));

export const LoadingProgress = (
  { fullscreen } : {
    fullscreen?: boolean;
  },
) => {
  const classes = useStyles();
  return (
    <Box className={classes.loading}>
      {fullscreen && (
      <div className={clsx(
        classes.loading,
        classes.overlay,
        { [classes.fullscreen]: fullscreen },
      )}
      />
      )}
      <Box
        id="loading-spinner"
        display="flex"
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        className={clsx(
          classes.loading,
          { [classes.fullscreen]: fullscreen },
        )}
      >
        <CircularProgress
          classes={{ root: classes.spinner }}
          size={28}
        />
      </Box>
    </Box>
  );
};
